// extracted by mini-css-extract-plugin
module.exports = {"container":"exclusive_service-module--container--D3Ol0","name":"exclusive_service-module--name--HAjkv"};